export default __webpack_public_path__ + "static/media/img_mcs_status-colorBkg.b7df676e.png";